
<nb-menu *ngIf="!bo_mostrarColapso" class="menu" [items]="item" (click)="ClickObtenerMenuPadre()"
  tag="Menu" > </nb-menu> 
  


 